import { Dropdown, Menu, Switch } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { renderStep } from "../../../helpers/renderViewHelper";
import { useMst } from "../../../store/root";
import styles from "./CompositionListMenu.module.scss";
import LoadingPng from "../../../assets/Ellipse6.png";
import { SelectIcon } from "../Icons";
import { CaretDownFilled } from "@ant-design/icons";
import {
  compositionsFromToday,
  compositionsRendered,
} from "../../../store/utils/utilMethods";
export const CompositionListMenu = observer(() => {
  const {
    uiStore: { setFilterCompositions, filterComposition },
    compositionStore: {
      selectedCompositionsId,
      sortedFilteredCompositions,
      setSelectedCompositions,
    },
    renderStore: { isRendering, saveCompStep },
    projectStore: { videoParts: scenes },
  } = useMst();
  const [selectView, setSelectView] = useState<"selectAll" | "unselect" | null>(
    null
  );
  useEffect(() => {
    if (selectedCompositionsId.length === 0) {
      setSelectView(null);
    } else if (selectedCompositionsId.length === sortedFilteredCompositions.length) {
      setSelectView("selectAll");
    } else {
      setSelectView("unselect");
    }
  }, [selectedCompositionsId.length]);

  const handleClick = () => {
    switch (selectView) {
      case null:
        sortedFilteredCompositions.forEach((comp) =>
          setSelectedCompositions(comp.id)
        );
        break;
      default:
        setSelectedCompositions(null);
        break;
    }
  };

  const menuItem = (
    text: string,
    newSelection: { id: number; name: string }[] | null
  ) => (
    <Menu.Item
      key={text}
      onClick={() => {
        setSelectedCompositions(null);
        newSelection &&
          newSelection.forEach((comp) => setSelectedCompositions(comp.id));
      }}
    >
      <p>{text}</p>
    </Menu.Item>
  );
  const menu = (
    <Menu className={styles.OverlayMenu}>
      {[
        {
          text: "All",
          newSelections: sortedFilteredCompositions,
        },
        {
          text: "None",
          newSelections: null,
        },
        {
          text: "Today",
          newSelections: compositionsFromToday(sortedFilteredCompositions, scenes),
        },
        {
          text: "Rendered",
          newSelections: compositionsRendered(
            true,
            sortedFilteredCompositions,
            scenes
          ),
        },
        {
          text: "Not Rendered",
          newSelections: compositionsRendered(
            false,
            sortedFilteredCompositions,
            scenes
          ),
        },
      ].map((item) => menuItem(item.text, item.newSelections))}
    </Menu>
  );

  const selectDropdown = (
    <div className={styles.SelectInfo}>
      <div onClick={handleClick} className={styles.SelectIcon}>
        <SelectIcon selectView={selectView} />
      </div>
      <div className={styles.selectDropdown}>
        <Dropdown overlay={menu} trigger={["click"]}>
          <CaretDownFilled />
        </Dropdown>
      </div>
      <div className={styles.NumberOfCompositions}>
        {`${selectedCompositionsId.length} Selected`}
      </div>
    </div>
  );

  return (
    <div className={styles.Menu}>
      <div className={styles.Left}>
        {isRendering ? (
          <div className={styles.Loading}>
            <img src={LoadingPng} className={styles.Rotate} />
            <p className={styles.RenderStep}>
              {renderStep[saveCompStep]}
              <span className={styles.dot1}>.</span>
              <span className={styles.dot2}>.</span>
              <span className={styles.dot3}>.</span>
            </p>
          </div>
        ) : (
          selectDropdown
        )}
      </div>
      <div className={styles.Right}>
        <p>Filter Selected</p>
        <Switch
          onChange={setFilterCompositions}
          checked={filterComposition}
          disabled={isRendering}
        />
      </div>
    </div>
  );
});
